<template>
  <div class="list-container">
    <author-jinNang-list :list="authorjinNangList"> </author-jinNang-list>
  </div>
</template>

<script>
import { getAuthorJinNangList } from '@/api/AuthorJinNang'
import AuthorJinNangList from '@/components/AuthorJinNangList/AuthorJinNangList'

export default {
  name: 'AuthorJinNangIndex',
  components: { AuthorJinNangList },
  data() {
    return {
      authorjinNangList: [],
      viewState: '',
      dialogVisible: false,
      pageSize: 50,
      pageIndex: 0,
      total: 0,
      orderby: 'desc'
    }
  },
  created() {
    this.getAuthorJinNangData()
  },
  computed: {},
  methods: {
    async getAuthorJinNangData() {
      const data = await getAuthorJinNangList(
        {
          pageSize: this.pageSize,
          pageIndex: this.pageIndex,
          orderby: this.orderby
        },
        this.viewState
      )
      if (data) {
        if (data.result.code === 0) {
          this.pageSize = data.detail.pageSize
          this.pageIndex = data.detail.pageIndex
          this.total = data.detail.total
          if (this.pageIndex === 0) {
            this.authorjinNangList = data.detail.list
          } else {
            this.authorjinNangList = this.authorjinNangList.concat(
              data.detail.list
            )
          }
        }
      }
    }
  }
}
</script>

<style scoped>
.list-container {
  background-color: #f0f0f0;
}
</style>
